module.exports = __webpack_public_path__ + "fff3dee81a436c0fcfe9000b105de08f.jpg";